<template>
    <div class="single-images__content-wrapper">
        <div class="single-images__img-wrapper" :data-order="key+1" v-for="(image, key) in currentVariation.images.all"
             :class="{ 'single-images__img-wrapper--full-width': !(currentVariation.images.all.length % 2) && (key === 0 || key === currentVariation.images.all.length - 1)}">
            <a :href="image.url" :data-lightbox="'single-item-image' + _uid">
                <img :src="image.url" alt="">
            </a>
        </div>
        <div v-if="video !== ''" data-order="3" class="single-images__img-wrapper single-images__img-wrapper--full-width single-images__img-wrapper--video">
            <video v-if="videoThumb !== ''" preload="none" :poster="videoThumb" :src="video" controls></video>
            <video v-else preload="metadata" :src="video" controls></video>
        </div>
    </div>
</template>
<script>

    import { isNullOrUndefined } from "ceres/app/helper/utils";

    export default {
        props: {
            currentVariation: Object
        },
        mounted()
        {
            this.$nextTick(() =>
            {
                // console.log('mounted')
                this.loadLightbox()
            });
        },

        computed:{
            video(){
                let video = "";

                if(this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0){
                    for(let key in this.currentVariation.variationProperties){
                        for(let keyInner in this.currentVariation.variationProperties[key].properties){
                            if(this.currentVariation.variationProperties[key].properties[keyInner].id === 4){
                                video = this.currentVariation.variationProperties[key].properties[keyInner].values.value;
                            }
                        }
                    }
                }

                return video;
            },

            videoThumb(){
                let videoThumb = "";

                if(this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0){
                    for(let key in this.currentVariation.variationProperties){
                        for(let keyInner in this.currentVariation.variationProperties[key].properties){
                            if(this.currentVariation.variationProperties[key].properties[keyInner].id === 5){
                                videoThumb = this.currentVariation.variationProperties[key].properties[keyInner].values.value;
                            }
                        }
                    }
                }

                return videoThumb;
            },
        },

        methods: {
            loadLightbox()
            {
                // console.log('lightbox')
                return new Promise((resolve, reject) =>
                {
                    const script = document.querySelector("script#lightboxscript");

                    if (!isNullOrUndefined(script))
                    {
                        resolve();
                        // console.log('if')
                    }
                    else
                    {
                        // console.log('else')
                        const script = document.createElement("script");

                        script.type = "text/javascript";
                        script.id = "lightboxscript";
                        script.src = `${ App.pluginPath }/js/dist/lightbox.min.js`;

                        script.addEventListener("load", () => resolve(), false);
                        script.addEventListener("error", event => reject(event), false);

                        document.body.appendChild(script);
                        // console.log('else end')

                    }
                });
            }
        }
    }
</script>
